import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { PlanScheduled } from "../../domain/models/scheduler/plan-scheduled";
import { PlanScheduledRepository } from "../../repositories/scheduler.repository";
import { PlanScheduledRequest } from "../../domain/requests/plans/get-scheduled-plans-request";

@Injectable({ providedIn: 'root' })
export class GetPlansScheduledUseCase implements UseCase<PlanScheduledRequest, PlanScheduled[]> {

  constructor(private readonly planScheduledRepository: PlanScheduledRepository) {
  }

  execute(request:PlanScheduledRequest): Observable<PlanScheduled[]> {
    return this.planScheduledRepository.getPlanScheduled(request);
  }

}
